.button {
    &:disabled,
    &[data-disabled] {
        border-color: transparent;
        background-color: transparent;
        color: var(--mantine-color-disabled);
        &:hover {
            color: var(--mantine-color-disabled);
        }
    }
}
